<template>
  <div>
    <div
      v-loading="loading"
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.3)">
    </div>
    <div class="main">
      <div class="left-section">
        <div class="news-list-bg">
          <div class="submission-tips">
            <h3>{{this.$t('common.instructions')}}</h3>
            <p>{{this.$t('common.instructions1')}}</p>
            <p>{{this.$t('common.instructions2')}}</p>
            <p>{{this.$t('common.instructions3')}}</p>
            <p>{{this.$t('common.instructions4')}}</p>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" :rules="ruleData" label-width="80px">
            <div class="sort-select">
              <el-form-item :label="$t('common.Column')" prop="type1">
                <el-select v-model="ruleForm.type1" :placeholder="$t('common.chooseColumn')">
                  <el-option v-for="item in classify1" :value="item.id" :key="item.id"
                             :label="language === 'en' ? item.enName : item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('common.Brands')" prop="type2">
                <el-select v-model="ruleForm.type2" :placeholder="$t('common.chooseBrand')">
                  <el-option v-for="item in classify2" :value="item.id" :key="item.id"
                             :label="language === 'en' ? item.enName : item.name"></el-option>
                </el-select>
              </el-form-item>
              <!--<el-form-item :label="$t('common.Column')" prop="type1">
                <el-select v-if="this.language === 'en'" v-model="ruleForm.type1" :placeholder="$t('common.chooseColumn')">
                  <el-option :label="item.enName" :value="item.id" :key="item.id"
                             v-for="item in classify1"></el-option>
                </el-select>
                <el-select v-else v-model="ruleForm.type1" :placeholder="$t('common.chooseColumn')">
                  <el-option :label="item.name" :value="item.id" :key="item.id"
                             v-for="item in classify1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('common.Brands')" prop="type2">
                <el-select v-if="this.language === 'en'" v-model="ruleForm.type2" :placeholder="$t('common.chooseBrand')">
                  <el-option :label="item.enName" :value="item.id" :key="item.id"
                             v-for="item in classify2"></el-option>
                </el-select>
                <el-select v-else v-model="ruleForm.type2" :placeholder="$t('common.chooseBrand')">
                  <el-option :label="item.name" :value="item.id" :key="item.id"
                             v-for="item in classify2"></el-option>
                </el-select>

              </el-form-item>-->
              <el-form-item :label="$t('common.Tools')" prop="type3">
                <el-select v-model="ruleForm.type3" :placeholder="$t('common.chooseTool')">
                  <el-option :label="item.name" :value="item.id" :key="item.id"
                             v-for="item in classify3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item :label="$t('common.Title')" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.Thumbnail')" prop="thumbnail">
              <el-upload
                action="http://hdd.mrtlab.com:8080/api/file/uploads"
                :headers="header"
                :file-list="fileList"
                name="files"
                list-type="picture-card"
                :limit=1
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
            <!--<el-form-item label="描述">-->
            <!--<el-input type="textarea" v-model="ruleForm.desc" :row="3"></el-input>-->
            <!--</el-form-item>-->
            <div class="sort-select">
              <el-form-item :label="$t('common.Source')" prop="source">
                <el-input v-model="ruleForm.source" style="width:300px;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('common.Language')" prop="language">
                <el-select v-model="ruleForm.language">
                  <el-option :label="$t('common.Chinese')" :value=0 :key=0></el-option>
                  <el-option :label="$t('common.English')" :value=1 :key=1></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-row>
              <el-col :span="7">
                <el-form-item :label="$t('common.Price')" prop="usd">
                  <el-input v-model.number="ruleForm.usd" class="price-input"></el-input>
                  <span>{{this.$t('common.USD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="rmb">
                  <el-input v-model.number="ruleForm.rmb" class="price-input"></el-input>
                  <span>{{this.$t('common.RMB')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="gold">
                  <el-input v-model.number="ruleForm.gold" class="price-input"></el-input>
                  <span>{{this.$t('common.Coins')}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('common.KeyWords')" prop="keyword">
              <el-input v-model="ruleForm.keyword"></el-input>
            </el-form-item>
            <!--editor的div为富文本的承载容器-->
            <el-form-item class="editor-box" :label="$t('common.Content')" prop="content">
              <script id="editor" type="text/plain"></script>
              <!--<div id="editor" v-model="content" placeholder="说点什么吧..."></div>-->
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="submitForm('ruleForm')">{{btnName}}</el-button>
              <el-button  type="success" plain @click="resetForm('ruleForm')">{{this.$t('common.Cancel')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '../axios'
  import hotComment from './comment/hotComment'
  import recommend from './comment/recommend.vue'
  import '../../static/Ueditor/ueditor.config.js'
  import '../../static/Ueditor/ueditor.all.js'
  import '../../static/Ueditor/lang/zh-cn/zh-cn.js'


  export default {
    name: "submission",
    data() {
      return {
        language: this.$store.state.lang,
        loading: true,
        fullscreenLoading: true,
        btnName: this.$t('common.Submission'),
        dialogImageUrl: '',
        dialogVisible: false,
        content: '',
        thumbnail: '',
        ruleForm: {
          desc: '',
          source: '',
          language: 0,
          type1: '',
          type2: '',
          type3: '',
          usd: 0,
          rmb: 0,
          gold: 0,
          keyword: '',
        },
        ruleData: {
          type1: [{required: true, message: this.$t('message.selectColumn'), trigger: 'change'}],
          title: [{required: true, message: this.$t('message.titleEmpty'), trigger: 'blur'}],
          source: [{required: true, message: this.$t('message.sourceEmpty'), trigger: 'blur'}],
          language: [{required: true, message: this.$t('message.chooseLanguage'), trigger: 'change'}],
          usd: [
            {required: true, message: this.$t('message.PriceEmpty'), trigger: 'blur'},
            {min: 0, type: 'number', message: this.$t('message.PriceZero'), trigger: 'blur'},
          ],
          rmb: [
            {required: true, message: this.$t('message.PriceEmpty'), trigger: 'blur'},
            {min: 0, type: 'number', message: this.$t('message.PriceZero'), trigger: 'blur'},
          ],
          gold: [
            {required: true, message: this.$t('message.PriceEmpty'), trigger: 'blur'},
            {min: 0, type: 'number', message: this.$t('message.PriceZero'), trigger: 'blur'},
          ],
        },
        classify1: [],
        classify2: [],
        classify3: [],
        fileList: [],
        header: {
          token: ''
        },
        articleId: ''
      }
    },
    components: {hotComment, recommend},
    created: function () {
      this.userIsLogin();
      this.classifyList();
      // 实例化editor编辑器
      // var editor = UE.getEditor('editor');
      this.articleId = this.$route.query.articleId;//跳转投稿页面编辑投稿ID
      //判断跳转进入投稿页面是新文章还是编辑我的投稿
      if (this.articleId != undefined && this.articleId != '' && this.articleId != null) {
        this.editSubmisssion();
        this.btnName = this.$t('userInfo.Change');
      }
    },
    mounted() {
      // 实例化editor编辑器
      this.editor = UE.getEditor('editor');
    },
    destroyed() {
      // 将editor进行销毁
      this.editor.destroy();
    },
    methods: {
      // 用户登录校验
      userIsLogin() {
        let _this = this;
        var token = localStorage.getItem('loginToken');
        this.header.token = token;
        if (token === '' || token == null) {
          _this.$message({
            title: _this.$t('message.Prompt'),
            message: _this.$t('message.login'),
            type: 'info',
            showClose: true,
            offset:300,
            duration:3000,
            onClose: function () {
              $(window).scrollTop(0);
              _this.$router.push('/');
              sessionStorage.setItem('menuIndex', "0");
            }
          });
        }
      },

      //提交投稿数据
      submitForm(ruleForm) {
        let _this = this;
        var postDate = _this.ruleForm;
        var content = _this.content;
        content = this.editor.getContent();
        var url;
        if (this.articleId != undefined && this.articleId != '' && this.articleId != null) {
          url = "update";
        } else {
          url = "add"
        }
        _this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            axios.post(this.$store.state.apiBasePath + "/article/" + url, {
              "id": _this.articleId,
              "content": content,
              "description": this.editor.getContentTxt().trim().substr(0, 200),
              "keyword": postDate.keyword,
              "usd": postDate.usd,
              "rmb": postDate.rmb,
              "gold": postDate.gold,
              "source": postDate.source,
              "language": postDate.language,
              "thumbnail": this.thumbnail,
              "title": postDate.title,
              "type1": postDate.type1,
              "type2": postDate.type2,
              "type3": postDate.type3,
            }).then(function (res) {
                if (res.data.code === 200) {
                  sessionStorage.setItem('menuIndex', 0);
                  _this.$message({
                    title: _this.$t('message.Success'),
                    message: _this.$t('message.SubmissionSuccess'),
                    type: 'success',
                    showClose: true,
                    offset:300,
                    duration:3000,
                    onClose: function () {
                      _this.$router.push('/');
                      $(window).scrollTop(0);
                    }
                  });
                } else {
                  _this.$message({
                    title: _this.$t('message.Error'),
                    message:res.data.msg,
                    type: 'error',
                    showClose: true,
                    offset:300,
                    duration:3000,
                  });
                }
              })
          }
        });
      },

      //修改投稿数据请求
      editSubmisssion() {
        let _this = this;
        axios.get(this.$store.state.apiBasePath + "/article/form/" + this.articleId)
          .then(function (res) {
            var res = res.data;
            if (res.code === 200) {
              _this.loading=false;
              _this.fullscreenLoading=false;
              _this.ruleForm = res.data;
              _this.content = res.data.content;
              var editor = UE.getEditor("editor");
              editor.ready(function () {
                editor.setContent(_this.content);
              });
              _this.thumbnail = res.data.thumbnail;

              if (res.data.thumbnail == null || res.data.thumbnail == '' || res.data.thumbnail == undefined) {
                _this.fileList = [];
              } else {
                _this.fileList = [{url: ''}];
                _this.fileList[0].url = _this.thumbnail;
              }
            } else {
              _this.$message({
                title: _this.$t('message.login'),
                message:res.data.msg,
                type: 'error',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },

      //  栏目分类请求数据
      classifyList() {
        let _this = this;
        axios.all([
          axios.get(this.$store.state.apiBasePath + "/classify/1"),
          axios.get(this.$store.state.apiBasePath + "/classify/2"),
          axios.get(this.$store.state.apiBasePath + "/classify/3"),
        ]).then(axios.spread(function (oneRes, twoRes, threeRes) {
          _this.loading=false;
          _this.fullscreenLoading=false;
          // 上面三个请求都完成后，才执行这个回调方法
          _this.classify1 = oneRes.data.data;
          _this.classify2 = twoRes.data.data;
          _this.classify3 = threeRes.data.data;
        })).catch(function (error) {
          _this.$message({
            title: _this.$t('message.login'),
            message:res.data.msg,
            type: 'error',
            showClose: true,
            offset:300,
            duration:3000,
          });

        });
      },

      resetForm(ruleForm) {
        if (this.articleId != undefined && this.articleId != '' && this.articleId != null) {
          this.$router.push('/mySubmission')
        } else {
          window.location.reload();
          $(window).scrollTop(0);
        }
      },

      //清除缩略图
      handleRemove(file, fileList) {
        this.thumbnail = '';
      },

      //上传缩略图
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //缩略图上传成功
      handleSuccess(response, file, fileList) {
        this.thumbnail = response.data[0].url;
      }
    },

  }
</script>

<style scoped lang="less">
   /deep/ .el-form-item__content {
    line-height: normal;
  }
   /deep/ .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label,
   /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label {
     &:before {
       content: '';
       color: #F56C6C;
       margin-right: 0
     }
     &:after {
       content: '*';
       color: #F56C6C;
       margin-left: 5px
     }
   }
  .main {
    width: 1170px;
    margin: 15px auto 15px auto;
    display: flex;
    justify-content: space-between;
  }

  .left-section {
    width: 100%;
    .news-list-bg {
      margin-bottom: 15px;
      padding: 20px 0;
      /*border: #ddd 1px solid;*/
      background: #fff;
    }
    .submission-tips {
      margin-left: 20px;
      margin-bottom: 40px;
      h3 {
        font-size: 20px
      }
      p {
        font-size: 14px;
        color: #e60000;
      }
    }
    .sort-select {
      display: flex;
    }
    .price-input {
      margin-right: 10px;
      width: 100px;
    }
  }

  .content-bg {
    padding: 15px 30px;
  }
  .content-title {
    color: #000;
    font-size: 20px;
    text-align: center;
  }
  .content-info {
    font-size: 14px;
    color: #777;
    text-align: center;
  }
  .content-info span {
    margin: 0 15px;
  }
  .content {
    text-align: justify;
    font-size: 14px;
    line-height: 26px;
  }
  .content p {
    margin: 0 0;
  }
  .content-bg img {
    display: block;
    max-width: 100%;
  }

  .news-img-bg h3 {
    font-size: 20px;
    color: #000;
    margin-left: 10px;
    text-align: left;
    line-height: 40px;
  }
  .news-img {
    width: 148px;
    height: 112px;
    display: block;
  }
  .news-img img {
    width: 148px;
    height: 112px;
    display: block;
  }
  .news-list-text {
    font-size: 14px;
    text-align: justify;
    display: flex;
    flex-wrap: wrap;
  }
  .news-list-text li {
    width: 50%;
  }
  .news-list-text li a {
    line-height: 35px;
    position: relative;
    padding: 0 15px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    color: #2c3e50;
    text-decoration: none;
    display: block;
  }
  .news-list-text li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 0;
    top: 15px;
  }
  .news-list ul li a:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #379ce9;
  }

  /*点击排行*/
  .click-ranking {
    width: 340px;
    box-sizing: border-box;
    border: #e5e5e5 1px solid;
  }
  .ranking-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    margin: 10px 10px;
    border-bottom: #e5e5e5 1px solid;
    padding-bottom: 8px;
  }
  .ranking-title span {
    color: #e60000;
  }
  .ranking-img {
    width: 100%;
    height: 160px;
  }
  .ranking-img-bg {
    position: relative;
    height: 160px;
  }
  .ranking-img-bg img {
    width: 100%;
    height: 160px;
  }
  .ranking-img-bg:hover {
    cursor: pointer;
  }
  .ranking-img-title {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
  }
  .ranking-img-title span {
    margin: 0 15px;
    display: block;
    font-size: 14px;
  }
  .hot-tag {
    background: url("../assets/homepage/hot.png") no-repeat;
    width: 31px;
    height: 57px;
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 16px;
    color: #fff;
    padding-top: 5px;
  }
  .ranking-list {
    margin-top: 10px;
    padding: 0 15px;

  }
  .ranking-list li {
    display: block;
    line-height: 28px;
    font-size: 14px;
    overflow: hidden;
    height: 28px;
    text-align: justify;
    color: #000;
  }
  .ranking-list li:hover {
    text-decoration: underline;
    color: #379ce9;
    cursor: pointer;
  }

  .ff0000 {
    color: #ff0000;
  }
  .ff5a00 {
    color: #ff5a00;
  }
  .ff7e00 {
    color: #ff7e00;
  }

  /*本站推荐*/
  .recommend-bg {
    border: #ddd 1px solid;
    margin-bottom: 10px;
  }
  .recommend-title span {
    color: #379ce9;
  }
  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }
  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }
  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }
  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }
  .active-title, .recommend-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    padding: 5px 0;
    margin: 10px 10px;
    border-bottom: #ddd 1px solid;
  }

  @media screen and (max-device-width: 1024px) {
    .main {
      width: 100%;
      overflow-x: auto
    }
    .news-list-bg {
      border: none;
    }
  }

  @media screen and (max-width: 767px) {
    /deep/ .el-form-item {
      display: block;
      .el-form-item__label {
        text-align: left;
      }
      .edui-toolbar {
        width: 100%;
      }
    }
    .editor-box {
      /deep/ .el-form-item__label {
        float: none;
      }
      /deep/ .el-form-item__content {
        margin-left: 0!important;
      }
    }
    .main {
      margin: 0;
    }
    .left-section {
      .news-list-bg {
        padding: 0 10px;
      }
      .submission-tips {
        margin: 40px 0;
        h3 {
          margin: 0;
        }
      }
      .sort-select {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/submission.vue